<script>
    import BenefitsCornerItem from './BenefitsCornerItem.svelte'

    import { Container } from '@/components'

    const data = [
        {
            icon: 'gears',
            description: `Квалифицированные сотрудники выполняют прямые обязанности, а не тратят рабочее время на формальности`
        },
        {
            icon: 'target',
            description: 'HR-специалисты фокусируются на найме и адаптации персонала, а не готовят стандартные формы по запросу'
        },
        {
            icon: 'checklist',
            description: 'Руководители занимаются развитием сотрудников и бизнеса, а не согласовывают кадровые заявки от подчинённых'
        }
    ]
</script>
<Container>
    <div class="wrapper">
        {#each data as { icon, description } }
            <BenefitsCornerItem {icon} {description} />
        {/each}
    </div>

    <div slot="background" class="background" />
</Container>

<style lang="scss" module>
    .wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding-top: 135px;
        padding-bottom: 141px;
    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% - (62px * 2));
        height: 100%;
        margin: 0 62px;
        background-image: url('../img/benefits-background.png');
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: bottom;
    }

    @media (max-width: 834px) {
        .wrapper {
            flex-wrap: wrap;
            justify-content: space-around;
            padding-top: 112px;
        }
    }

    @media (max-width: 420px) {
        .wrapper {
            display: block;
            padding-top: 0;
        }
    }
</style>